import { Stats } from './types';

// Discover actual team IDs from the stats response keys
// The raw API JSON uses team IDs as keys in teams/general/etc objects
// These may differ from the match's homeTeamId/awayTeamId
export const discoverTeamIds = (
  stats: Stats,
  homeTeamId: number,
  awayTeamId: number,
  homeTeamName?: string
): { homeId: string; awayId: string } => {
  const matchHomeId = String(homeTeamId);
  const matchAwayId = String(awayTeamId);

  // Get all team IDs from the stats response
  const statsTeamIds = Object.keys(stats.teams || stats.general || {}).filter(
    k => /^\d+$/.test(k)
  );

  if (statsTeamIds.length < 2) {
    return { homeId: matchHomeId, awayId: matchAwayId };
  }

  // If match team IDs exist in the stats, use them directly
  if (statsTeamIds.includes(matchHomeId) && statsTeamIds.includes(matchAwayId)) {
    return { homeId: matchHomeId, awayId: matchAwayId };
  }

  // Match team IDs don't align with stats keys - map by name matching
  const id1 = statsTeamIds[0];
  const id2 = statsTeamIds[1];
  const name1 = stats.teams?.[id1]?.team?.name?.toLowerCase() || '';
  const name2 = stats.teams?.[id2]?.team?.name?.toLowerCase() || '';
  const homeName = (homeTeamName || '').toLowerCase();

  if (homeName && name1.includes(homeName.split(' ')[0])) {
    return { homeId: id1, awayId: id2 };
  }
  if (homeName && name2.includes(homeName.split(' ')[0])) {
    return { homeId: id2, awayId: id1 };
  }

  // Last resort: if one matches the match homeTeamId, use it
  if (statsTeamIds.includes(matchHomeId)) {
    const other = statsTeamIds.find(id => id !== matchHomeId)!;
    return { homeId: matchHomeId, awayId: other };
  }
  if (statsTeamIds.includes(matchAwayId)) {
    const other = statsTeamIds.find(id => id !== matchAwayId)!;
    return { homeId: other, awayId: matchAwayId };
  }

  // Fallback: first is home, second is away
  return { homeId: id1, awayId: id2 };
};
